export default __webpack_public_path__ + "static/icon-awtgs-grade-5-260x260-aa278fdf7c0740ba39c4921eae1de0ae.jpg";